/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import { FunctionComponent } from "react";
import { TwitterTweetEmbed } from "react-twitter-embed";
import Url from "url-parse";

import { StrapiEmbedPrimitive } from "@/types/strapi";

import { Gist } from "./gist";

interface EmbedProps extends StrapiEmbedPrimitive {
    className?: SerializedStyles;
}

export const Embed: FunctionComponent<EmbedProps> = (props) => {
    const { hostname, pathname } = new Url(props.URL);

    /**
     * Rendering
     */
    const renderBlock = () => {
        switch (hostname) {
            case "gist.github.com": {
                return <Gist {...props} />;
            }
            case "twitter.com":
            case "x.com": {
                const tweetId = pathname.split("/").at(-1);
                return (
                    tweetId && (
                        <div
                            css={css({
                                /**
                                 * The iframe is sized with JS, and flexbox
                                 * or margin auto do not work for centering
                                 * Unfortunately this does work.
                                 */
                                "& > div": {
                                    "& > div": {
                                        transform: "translateX(-50%)",
                                    },
                                    transform: "translateX(50%)",
                                },
                                overflow: "hidden",
                            })}
                        >
                            <TwitterTweetEmbed tweetId={tweetId} />
                        </div>
                    )
                );
            }
            default:
                return null;
        }
    };
    return <>{renderBlock()}</>;
};
